import * as React from "react";

function SvgProofExperiences(props, ref) {
  return (
    <svg
      id="ProofExperiences_svg__Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x={0}
      y={0}
      viewBox="0 0 298.5 298.4"
      xmlSpace="preserve"
      width="1em"
      height="1em"
      {...{ ...props, ref }}
    >
      <style />
      <linearGradient
        id="ProofExperiences_svg__SVGID_1_"
        gradientUnits="userSpaceOnUse"
        x1={144.4}
        y1={886.2}
        x2={144.4}
        y2={1014.2}
        gradientTransform="translate(0 -801)"
      >
        <stop offset={0} stopColor="#ff1493" />
        <stop offset={0.39} stopColor="#fd576c" />
        <stop offset={0.81} stopColor="#fc9847" />
        <stop offset={1} stopColor="#fbb138" />
      </linearGradient>
      <path
        d="M125.2 133.2h78.4c-3.8 18.6-20.2 32-39.2 32H85.2c3.8-18.6 20.2-32 39.2-32h.8zm78.4-16c-3.8-18.6-20.2-32-39.2-32h-40v32h79.2zm-79.2 96c19 0 35.4-13.4 39.2-32h-39.2v32z"
        fill="url(#ProofExperiences_svg__SVGID_1_)"
      />
    </svg>
  );
}

export default React.forwardRef(SvgProofExperiences);
